import { createAsyncThunk } from "@reduxjs/toolkit";
import FreeTrialServices from "./../../Services/freeTrialServices";
import { ResponseMessageHandler } from "../../globals/components/notification";

export const CompanySignup = createAsyncThunk(
  "FreeTrial/CompanySignup",
  async (data, thunkAPI) => {
    try {
      let res = await FreeTrialServices.companySignupAPI({
        ...data,
      });
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
